import React, { useContext, useEffect, useRef, useState } from "react";
// import { withRouter } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { Dropdown } from "primereact/dropdown";
import { OverlayPanel } from "primereact/overlaypanel";
import { Sidebar } from "primereact/sidebar";
import { useNavigate } from "react-router-dom";

import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { toast } from "react-toastify";
import { RootStoreContext } from "../../stores/rootStore";
import Loading from "../Loading/Loading";
import "./TitleBar.css";
import cssClass from "./TitleBar.module.css";
import TitleBarAccountPanel from "./TitleBarAccountPanel/TitleBarAccountPanel";
import TitleBarSidePanel from "./TitleBarSidePanel/TitleBarSidePanel";

const TitleBar = () => {
  const navigate = useNavigate();

  const op = useRef(null);
  const toolsMenu = useRef(null);
  const modelsMenu = useRef(null);
  const [visibleLeft, setVisibleLeft] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState(null); // no preselection
  const rootStore = useContext(RootStoreContext);
  const { user } = rootStore.userStore;
  const { fetchingAppVars, appVars, fetchAppVars } = rootStore.generalStore;
  const { loadingProjects, fetchProjects, projectRegistry } =
    rootStore.projectStore;

  useEffect(() => {
    if (appVars === null) {
      fetchAppVars();
    }
    if (projectRegistry.size === 0) {
      fetchProjects();
    }
  }, [appVars, fetchAppVars, fetchProjects, projectRegistry]);

  if (fetchingAppVars) {
    return <Loading />;
  }

  const projects = Array.from(projectRegistry.values())
    .filter((p) => p.projectName)
    .sort((a, b) => (a.projectName || "").localeCompare(b.projectName || ""));

  const FeedbackOptions = [
    { label: "Bug Report", value: "bug-report" },
    { label: "Feature Request", value: "feature-request" },
    { label: "Data Discrepancy ", value: "data-discrepancy" },
  ];

  const toolsItems = [
    {
      label: "Verify",
      icon: "pi pi-verified",
      command: () => navigate("/tools/verify/"),
    },
    {
      label: "Editor",
      icon: "pi pi-pencil",
      command: () => navigate("/tools/editor/"),
    },
    {
      label: "Molecular Design",
      icon: "pi pi-sitemap",
      command: () => navigate("/tools/moldesign/"),
    },
  ];

  const modelsItems = [];

  const onSelectProject = (e) => {
    if (e.value) {
      setSelectedProjectId(e.value);
      navigate("/pm/project/" + e.value + "/");
    }
  };

  const projectOptionTemplate = (option) => {
    return (
      <div className="flex gap-3 align-items-center">
        <i className="icon icon-species icon-plasmodium" />
        <div className="flex flex-column">
          <span style={{ fontWeight: 500 }}>{option.projectName}</span>
          {option.targetName && (
            <small style={{ opacity: 0.7 }}>{option.targetName}</small>
          )}
        </div>
      </div>
    );
  };

  const feedbackOptionTemplate = (option) => {
    const iconClass = (option) => {
      switch (option.value) {
        case "bug-report":
          return "icon icon-common icon-bug";
        case "feature-request":
          return "icon icon-common icon-new";
        case "data-discrepancy":
          return "icon icon-common icon-database";
      }
    };
    return (
      <div className="flex gap-3">
        <i className={iconClass(option)} />
        <div>{option.label}</div>
      </div>
    );
  };

  let onFeedback = (e) => {
    navigate("/developer/" + e.value);
  };

  return (
    <div className={cssClass.Header}>
      <Sidebar
        visible={visibleLeft}
        baseZIndex={1000000}
        onHide={() => setVisibleLeft(false)}
      >
        <TitleBarSidePanel toggle={() => setVisibleLeft(false)} user={user} />
      </Sidebar>
      <div className={["inline-flex", cssClass.Feedback].join(" ")}>
        <Button
          type="Button"
          icon="icon icon-common icon-th"
          className={["mr-2", cssClass.BlackButton, cssClass.Feedback].join(
            " "
          )}
          onClick={() => setVisibleLeft(true)}
        />
        <div className="LogoButton m-1">
          <Button
            onClick={() => {
              setSelectedProjectId(null);
              navigate("/d/");
            }}
            className={[
              "pr-2 pl-2",
              "p-button-text p-button-plain",
              cssClass.LogoText,
              cssClass.BlackButton,
            ].join(" ")}
          >
            <b>{rootStore.generalStore.appVars?.siteName || "D A I K O N"}</b>
          </Button>
        </div>

        {/* <Button
          type="Button"
          icon="pi pi-sliders-v"
          label="View"
          className={["p-mr-2", cssClass.BlackButton].join(" ")}
        /> */}

        <div className="absolute right-0">
          <Dropdown
            value={selectedProjectId}
            options={projects}
            onChange={(e) => onSelectProject(e)}
            optionLabel="projectName"
            optionValue="id"
            placeholder="Projects"
            className={[cssClass.BlackButton, "Strain"].join(" ")}
            style={{ color: "white", minWidth: "100px" }}
            itemTemplate={projectOptionTemplate}
          />
          {/* Feedback dropdown */}
          {/* <Dropdown
            options={FeedbackOptions}
            onChange={(e) => onFeedback(e)}
            optionLabel="label"
            placeholder="Feedback"
            className={[cssClass.BlackButton, "Feedback"].join(" ")}
            itemTemplate={feedbackOptionTemplate}
          /> */}
          {/* Sync button */}
          {/* <Button
            type="Button"
            icon="ri-refresh-fill"
            label="Sync"
            className={[cssClass.Push, cssClass.BlackButton].join(" ")}
            onClick={() => window.location.reload()}
          /> */}

          {/* Compounds */}
          <Button
            type="button"
            icon="pi pi-chevron-circle-right"
            label="Compounds"
            className={[cssClass.BlackButton, "mr-1"].join(" ")}
            style={{ color: "white" }}
            onClick={() => navigate("/tools/compounds/")}
          />

          {/* Tools dropdown */}
          <Button
            type="button"
            icon="pi pi-cog"
            label="Tools"
            className={[cssClass.BlackButton, "mr-1"].join(" ")}
            style={{ color: "white" }}
            onClick={(e) => toolsMenu.current.toggle(e)}
          />
          <Menu model={toolsItems} popup ref={toolsMenu} id="tools-menu" />

          {/* Models dropdown */}
          <Button
            type="button"
            icon="pi pi-chart-line"
            label="Models"
            className={[cssClass.BlackButton, "mr-1"].join(" ")}
            style={{ color: "white" }}
            onClick={(e) => modelsMenu.current.toggle(e)}
          />
          <Menu model={modelsItems} popup ref={modelsMenu} id="models-menu" />

          <Button
            type="Button"
            className={[cssClass.BlackButton].join(" ")}
            icon="pi pi-user"
            label={user?.email || "Dev User"}
            onClick={(e) => op.current.toggle(e)}
          />
          <OverlayPanel dismissable ref={op}>
            <TitleBarAccountPanel />
          </OverlayPanel>
        </div>
      </div>
    </div>
  );
};

//export default withRouter(observer(TitleBar));
export default observer(TitleBar);
